var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSslMappings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 82,
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.5 17 .223-.301c-3.8-.95-6.585-4.037-6.585-7.699 0-4.418 4.053-8 9.054-8h126.754c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 65 0 61.418 0 57s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h49.046Zm129.446 32c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 36.582 216 41s-4.054 8-9.054 8ZM77.501 17A38.825 38.825 0 0 0 70 40c0 21.54 17.46 39 39 39 18.094 0 33.31-12.322 37.715-29.033A39.06 39.06 0 0 0 148 40c0-17.582-11.634-32.447-27.624-37.315A38.997 38.997 0 0 0 109 1C96.196 1 84.834 7.17 77.723 16.699a10.18 10.18 0 0 0 2.469.301H77.5Z",
    fill: "#7F7F7F",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m104.752 51.404-2.81 3.012A8.5 8.5 0 1 1 89.51 42.822l9.547-10.238a8.5 8.5 0 1 1 12.433 11.594l-1.919 2.057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.615 30.276 3.442-3.692a8.5 8.5 0 0 1 12.014-.42h0a8.5 8.5 0 0 1 .42 12.014l-9.548 10.238a8.5 8.5 0 1 1-12.433-11.594l1.75-1.877"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109 80c18.094 0 33.31-12.322 37.715-29.033A39.06 39.06 0 0 0 148 41c0-17.582-11.634-32.447-27.624-37.315A38.997 38.997 0 0 0 109 2C87.46 2 70 19.46 70 41s17.46 39 39 39Z",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSslMappings);
export default __webpack_public_path__ + "static/media/ssl-mappings.7f7328265fc1fb84e2aec8a6f87f663c.svg";
export { ForwardRef as ReactComponent };